import React, { useState } from 'react';

import {
    SelectField,
    Cell,
    TextField,
} from "react-md";
import { DEFAULT_ZERO_POINT_RADIUS, DEFAULT_ZERO_POINT_COLOR, DEFAULT_LATEX_SYMBOL_SIZE, SymbolType } from '../../pages/AssignmentMatrix/Constants';
import { Tooltip, Typography } from "@mui/material"
import { colorsArray } from './commonHelpers';
import { BsInfoCircleFill } from "react-icons/bs";
import ColorPickerField from './ColorPickerField';

const symbolArray = [
    {
        label: "In-Plane Arrow",
        value: SymbolType.IN_PLANE,
    },
    {
        label: "Solid Dot",
        value: SymbolType.SOLID_DOT,
    },
    {
        label: "Out (odot)",
        value: SymbolType.OUT_ODOT,
    },
    {
        label: "In (otimes)",
        value: SymbolType.IN_OTIMES,
    }
]

const ZeroAndSymbolVectorFields = ({
    index,

    latexSymbol,
    onLatexSymbolChange,

    latexSymbolSize,
    onLatexSymbolSizeChange,

    zeroVectorPointRadius,
    onChangeZeroVectorRadius,

    zeroVectorPointColor,
    onChangeZeroVectorPointColor,
}) => {


    return (
        <React.Fragment>

            {/* Symbol dropdown */}
            <Cell size={3}>
                <div style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                }}>
                    {/* <Tooltip
                        title={
                            <Typography className='text-white' fontSize={12}>
                                <div>
                                    Zero Vector will be visible only when x and y values are ZERO.
                                </div>
                            </Typography>
                        }>
                        <span style={{ cursor: "pointer", marginTop: "10px", marginRight: "8px" }}>
                            <BsInfoCircleFill color='#737373' />
                        </span>
                    </Tooltip> */}
                    <SelectField
                        id={`zero-vector-symbol-${index}`}
                        label="Select Symbol Type"
                        fullWidth
                        onChange={(value) => {
                            console.debug("value>>>", value, typeof value)
                            onLatexSymbolChange(value)
                        }}
                        menuItems={symbolArray}
                        value={latexSymbol}
                    />
                </div>
            </Cell>

            {latexSymbol === SymbolType.SOLID_DOT ?
                <React.Fragment>
                    <Cell size={3}>
                        <TextField
                            className="textFieldClass"
                            value={zeroVectorPointRadius ? zeroVectorPointRadius : DEFAULT_ZERO_POINT_RADIUS}
                            label="Solid Dot Radius"
                            type="number"
                            id={`radius-${index}`}
                            onChange={(value) => {
                                onChangeZeroVectorRadius(value);
                            }}
                        />
                    </Cell>
                    {/* <Cell size={3}>
                        <ColorPickerField
                            value={zeroVectorPointColor ?  zeroVectorPointColor : DEFAULT_ZERO_POINT_COLOR}
                            onChange={(value) => {
                                onChangeZeroVectorPointColor(value);
                            }}
                        />
                    </Cell> */}
                </React.Fragment>
                : null}

            {latexSymbol === SymbolType.OUT_ODOT || latexSymbol === SymbolType.IN_OTIMES ?
                <React.Fragment>
                    <Cell size={3}>
                        <TextField
                            className="textFieldClass"
                            value={latexSymbolSize ? latexSymbolSize : DEFAULT_LATEX_SYMBOL_SIZE}
                            label="Type Size"
                            type="number"
                            id={`symbol-size-${index}`}
                            onChange={(value) => {
                                let val = parseInt(value, 10);
                                if (val <= 0) {
                                    alert("Symbol size cannot be negative");
                                    return;
                                }
                                onLatexSymbolSizeChange(parseInt(value, 10))
                            }}
                        />
                    </Cell>
                </React.Fragment>
                : null}


        </React.Fragment>
    );
}

export default ZeroAndSymbolVectorFields;
